import { RoomApi } from '../../api-clients';
import { wrap } from '../../wrap';

export const vhPresentationApi = {
  index: wrap(RoomApi, RoomApi.prototype.indexVhPresentList),
};
